import {css} from '../theme/css'
import {spacing} from '../theme/theme'
import {cssTheme} from '../v2'

export const classes = {
  root: css`
    inline-size: max-content;
    margin: auto;
    min-block-size: 100vh;
    background: ${cssTheme.default.day.background};
    text-align: center;
  `,
  description: css`
    margin-block-start: ${spacing(1)};
    margin-block-end: ${spacing(3)};
  `,
  image: css`
    margin-block-start: ${spacing(8)};
  `,
  reqId: css`
    font-size: ${cssTheme.fonts.sizes.caption1};
    margin-block-start: ${spacing(2)};
    color: ${cssTheme.colors.chrome[400]};
  `,
}
